import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'worktime' })
export class WorkTimePipe implements PipeTransform {
    transform(date: any, charBetween: string): string {
        if (!date) { return '/'; }
        let days: string = moment(date).format('DD');
        let hours: string = moment(date).format('HH');
        let totalHours: Number = (Number(days) - 1) * 24 + Number(hours);
        return totalHours + charBetween + moment(date).format('mm');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/pipes/worktime-pipe.ts